<template>
  <div class="page" style="pointer-events:none;" :class="[scrollContent ? 'scroll-content' : '']">    
    <PageFull contain>
    <template v-slot:page>
        <div ref="content">        
            <div class="all-content">              
                <div class="image"><img src="@/assets/images/routing/bg_route-map.jpg" alt=""></div>
                <RoutingMap />                                
                <div class="page-content content">
                  <transition name="slide-fade" mode="out-in" appear>
                    <TitleContent h2="Las Vegas Market" h1="Routing" />                    
                  </transition>
                  <transition name="slide-fade" mode="out-in" appear>
                    <div class="text-content">
                        <p>Las Vegas is located in the center of the West Coast’s major routing markets. Routing to Las Vegas is convenient for any touring show from 8 major markets.</p>
                    </div>
                  </transition>
                </div>                
            </div>
        </div>
    </template>
    </PageFull>    
  </div>
</template>

<script>
import PageFull from "@/patterns/PageFull.vue";
import TitleContent from "@/patterns/TitleContent.vue";
import RoutingMap from "@/components/RoutingMap.vue";

export default {
  name: "TheStadium",
  components: { PageFull, TitleContent, RoutingMap },
  data: () => ({
    scrollContent: false,    
  }),  
  mounted() {
    window.addEventListener("resize", this.shouldScrollContent);
  },
  beforeDestroy: function () {
    window.removeEventListener("resize", this.shouldScrollContent);
  },
  methods: {
    shouldScrollContent() {
      this.scrollContent =
        this.$refs.content.clientHeight > window.innerHeight ? true : false;
    },
  },
};
</script>

<style lang="scss" scoped>  
p {
    max-width: 470px;
}
</style>
